import type { Event } from '@patsnap/tahiti-core';
import type { TaskItem } from '../types';

export const TaskStatusSyncService = Symbol.for('TaskStatusSyncService');

export interface TaskStatusSyncService {
    /**
     * 订阅数据变化
     */
    readonly onTaskStatusChange: Event<TaskItem[]>;
    /**
     * 扫描任务状态
     */
    scanTaskStatus(data: TaskItem[]): Promise<void>;
}
